'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/design-system/components/ds/icon';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { useLocalizedPath } from '@repo/i18n/hooks/use-localized-path';
import { css, cx } from '@repo/panda/css';
import { Box, Stack } from '@repo/panda/jsx';
import { button } from '@repo/panda/recipes';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectTitleId } from '@repo/store/maps/slices/mapData';
import { Link } from '@repo/ui/components/link/link';
import { Trans } from 'react-i18next';
import compassCardBg from '../../assets/compass-cta-card-bg.webp';
import liveLocationCardBg from '../../assets/live-location-cta-card-bg.webp';
import liveLocationGlyph from '../../assets/live-location-cta-glyph.webp';
import teleportCardBg from '../../assets/teleport-cta-card-bg.webp';
import { useMapDownloadPath } from '../utils/use-map-download-path';
interface MapFeatureCtaCardProps {
  feature: 'compass' | 'liveLocation' | 'teleport';
  isMobilePane?: boolean;
  onClose: () => void;
  onDownloadClick: () => void;
}
function MapFeatureCtaCard(t0) {
  const $ = _c(65);
  const {
    feature,
    isMobilePane: t1,
    onClose,
    onDownloadClick
  } = t0;
  const isMobilePane = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["game_map"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useT(t2);
  const localizedPath = useLocalizedPath();
  const mapId = useAppSelector(selectExternalMapId);
  const titleId = useAppSelector(selectTitleId);
  let t3;
  if ($[1] !== mapId || $[2] !== titleId) {
    t3 = {
      mapId,
      titleId
    };
    $[1] = mapId;
    $[2] = titleId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const downloadPath = useMapDownloadPath(feature === "compass" ? "compass_cta" : feature === "teleport" ? "location_teleport" : "live_location_cta", t3);
  let t4;
  if ($[4] !== feature || $[5] !== t) {
    t4 = feature === "compass" ? t(_temp) : feature === "teleport" ? t(_temp2) : t(_temp3);
    $[4] = feature;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const closeAriaLabel = t4;
  let t5;
  if ($[7] !== feature || $[8] !== t) {
    t5 = feature === "compass" ? t(_temp4) : feature === "teleport" ? t(_temp5) : t(_temp6);
    $[7] = feature;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const title = t5;
  let t6;
  if ($[10] !== feature || $[11] !== t) {
    t6 = feature === "compass" ? t(_temp7) : feature === "teleport" ? t(_temp8) : t(_temp9);
    $[10] = feature;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const downloadCta = t6;
  const cardBackground = feature === "compass" ? compassCardBg : feature === "teleport" ? teleportCardBg : liveLocationCardBg;
  const t7 = isMobilePane ? "full" : "[340px]";
  const t8 = isMobilePane ? "full" : "[calc(100vw - 112px)]";
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = css({
      position: "relative",
      width: t7,
      maxWidth: t8,
      overflow: "hidden",
      borderRadius: "32",
      backgroundColor: "[rgba(0, 0, 0, 0.8)]",
      backdropFilter: "[blur(16px)]",
      boxShadow: "lg"
    });
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = css({
      position: "absolute",
      top: "20",
      right: "20",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "[32px]",
      height: "[32px]",
      padding: "4",
      borderWidth: "0",
      borderRadius: "full",
      backgroundColor: "white",
      color: "black",
      cursor: "pointer",
      filter: "[drop-shadow(0 1px 0 rgba(0, 0, 0, 0.3))]",
      _hover: {
        backgroundColor: "grey.100"
      },
      _focusVisible: {
        outline: "[2px solid token(colors.brand.primary)]",
        outlineOffset: "2"
      }
    });
    t11 = <Icon icon="close" size="sm" decorative={true} />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  if ($[18] !== closeAriaLabel || $[19] !== onClose) {
    t12 = <button type="button" aria-label={closeAriaLabel} onClick={onClose} className={t10}>{t11}</button>;
    $[18] = closeAriaLabel;
    $[19] = onClose;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = css({
      position: "relative",
      height: "[140px]",
      marginBottom: "[-24px]",
      overflow: "hidden"
    });
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = cardBackground.src;
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = css({
      position: "absolute",
      inset: "0",
      width: "full",
      height: "full",
      objectFit: "cover"
    });
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== cardBackground.src) {
    t16 = <img src={t14} alt="" className={t15} aria-hidden="true" />;
    $[23] = cardBackground.src;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== feature) {
    t17 = feature !== "teleport" && <Box className={css({
      position: "absolute",
      inset: "0",
      background: "[linear-gradient(to bottom, transparent 55%, rgba(0, 0, 0, 0.8) 100%)]"
    })} aria-hidden="true" />;
    $[25] = feature;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = <Box className={t13}>{t16}{t17}</Box>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = css({
      position: "relative",
      width: "[48px]",
      height: "[48px]"
    });
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== feature) {
    t20 = <Box className={t19}>{feature === "compass" ? <Icon icon="assistant_navigation" fill={true} className={css({
        fontSize: "[48px]",
        color: "brand.primary",
        transform: "rotate(45deg)"
      })} decorative={true} /> : feature === "teleport" ? <Box className={css({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "[48px]",
        height: "[48px]",
        borderRadius: "full",
        backgroundColor: "brand.primary"
      })}><Icon icon="sprint" size="lg" fill={true} decorative={true} className={css({
          color: "black"
        })} /></Box> : <img src={liveLocationGlyph.src} alt="" className={css({
        position: "absolute",
        top: "[-31px]",
        left: "[4px]",
        width: "[80px]",
        height: "[80px]",
        maxWidth: "[none]"
      })} aria-hidden="true" />}</Box>;
    $[31] = feature;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = css({
      whiteSpace: "nowrap"
    });
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== title) {
    t22 = <Type variant="header-m" color="white" className={t21}>{title}</Type>;
    $[34] = title;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = css({
      color: "[rgba(255, 255, 255, 0.8)]"
    });
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== feature) {
    t24 = $_8 => feature === "compass" ? $_8.compass_cta.body : feature === "teleport" ? $_8.teleport_cta.body : $_8.live_location_cta.body;
    $[37] = feature;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      bold: <Box as="span" fontWeight="medium" />
    };
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t24) {
    t26 = <Type variant="body-s" className={t23}><Trans i18nKey={t24} ns="game_map" components={t25} /></Type>;
    $[40] = t24;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t22 || $[43] !== t26) {
    t27 = <Stack gap="8">{t22}{t26}</Stack>;
    $[42] = t22;
    $[43] = t26;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t20 || $[46] !== t27) {
    t28 = <Stack gap="8" paddingX="20" paddingBottom="[28px]" marginBottom="[-24px]" position="relative" zIndex="1">{t20}{t27}</Stack>;
    $[45] = t20;
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== downloadPath || $[49] !== localizedPath) {
    t29 = localizedPath(downloadPath);
    $[48] = downloadPath;
    $[49] = localizedPath;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = cx(button({
      variant: "filled",
      color: "brand",
      size: "lg",
      fullWidth: true
    }));
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  const t31 = feature === "teleport" ? "download" : "window";
  let t32;
  if ($[52] !== t31) {
    t32 = <Icon icon={t31} fill={true} decorative={true} />;
    $[52] = t31;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  let t33;
  if ($[54] !== downloadCta || $[55] !== onDownloadClick || $[56] !== t29 || $[57] !== t32) {
    t33 = <Stack gap="6" paddingX="20" paddingTop="16" paddingBottom="20"><Link href={t29} onClick={onDownloadClick} className={t30}>{t32}{downloadCta}</Link></Stack>;
    $[54] = downloadCta;
    $[55] = onDownloadClick;
    $[56] = t29;
    $[57] = t32;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] !== t12 || $[60] !== t18 || $[61] !== t28 || $[62] !== t33 || $[63] !== t9) {
    t34 = <Stack gap="0" className={t9}>{t12}{t18}{t28}{t33}</Stack>;
    $[59] = t12;
    $[60] = t18;
    $[61] = t28;
    $[62] = t33;
    $[63] = t9;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  return t34;
}
function _temp9($_7) {
  return $_7.live_location_cta.download_cta;
}
function _temp8($_6) {
  return $_6.teleport_cta.download_cta;
}
function _temp7($_5) {
  return $_5.compass_cta.download_cta;
}
function _temp6($_4) {
  return $_4.live_location_cta.title;
}
function _temp5($_3) {
  return $_3.teleport_cta.title;
}
function _temp4($_2) {
  return $_2.compass_cta.title;
}
function _temp3($_1) {
  return $_1.live_location_cta.close_aria_label;
}
function _temp2($_0) {
  return $_0.teleport_cta.close_aria_label;
}
function _temp($) {
  return $.compass_cta.close_aria_label;
}
export function LiveLocationCtaCard(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MapFeatureCtaCard {...props} feature="liveLocation" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function CompassCtaCard(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MapFeatureCtaCard {...props} feature="compass" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TeleportCtaCard(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MapFeatureCtaCard {...props} feature="teleport" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}